class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.cartDrawerToggle = document.querySelector('.section-header-cart-drawer-toggle');
        this.cartDrawer = this;

        this.setAttribute('tabindex', '-1');

        if (this.cartDrawerToggle) {
            this.cartDrawerToggle.addEventListener('click', (event) => this.onClick(event));
        }

        // USE EVENT DELEGATION: Listen on the host element so innerHTML updates don't break listeners
        this.addEventListener('click', (event) => {
            if (event.target.closest('.cart-drawer-close') || 
                event.target.closest('.cart-drawer-overlay') || 
                event.target.closest('.cart-drawer-empty-footer')) {
                this.close();
            }
        });

        this.addEventListener('keyup', (event) => {
            if (event.target.closest('.cart-drawer-close') && event.key === 'Enter') {
                this.close();
            }
        });

        document.addEventListener('keyup', (event) => {
            if (event.key === 'Escape') {
                this.close();
            }
        });

        this.previousElement = this.cartDrawerToggle;
    }

    onClick(event) {
        event.preventDefault();
        this.open();
    }

    open() {
        this.previousElement = (document.activeElement || this.cartDrawerToggle);

        this.cartDrawer.setAttribute('aria-hidden', 'false');
        this.cartDrawer.classList.add('active');

        setTimeout(() => {
            var focusTarget = this.querySelector('a[href], button');
            if (focusTarget) focusTarget.focus();
        }, 100);
    }

    close() {
        if (this.previousElement && typeof this.previousElement.focus === 'function') {
            this.previousElement.focus();
        }
            
        this.cartDrawer.setAttribute('aria-hidden', 'true');
        this.cartDrawer.classList.remove('active');

        var quickviewElement = document.querySelector('.popup-modal-quickview:not(.inactive)');
        if (quickviewElement) {
            var submitBtn = quickviewElement.querySelector('button[type="submit"]');
            if (submitBtn) submitBtn.focus();
        }
    }
}

customElements.define('cart-drawer', CartDrawer);

// Example callback after updating/removing items via AJAX
function handleCartUpdate(cart) {
    const recommendationsContainer = document.querySelector('.cart-drawer-recommendations');
    
    if (recommendationsContainer) {
        if (cart.item_count === 0) {
            recommendationsContainer.style.display = 'none';
        } else {
            recommendationsContainer.style.display = 'block';
        }
    }
}